<template>
  <div class="printContainer">
    <slot name='printContent'></slot>
  </div>
</template>
<script>
export default {
  name: 'printSheet',
};
</script>
<style lang="less" scoped>
  .printContainer{
    display: none;
  }
@media print {
.printContainer{
  display: block;
  }
}
</style>
